import React from 'react';
import styles from './index.module.scss';

import { Card, Form, Button, Row, Col } from 'react-bootstrap';

const DevicesForm = (props) => {


    return (
        <Card>
            <Card.Body>
                <Form>
                    <h5>Add New Device</h5>
                    <hr />
                    <Form.Group>
                        <Form.Label>Device Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter the device name" />
                    </Form.Group>
                    {/* Price */}
                    <h5 className={styles.SubTitle}>Price</h5>
                    <hr className={styles.SubDivider} />
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Regular Price</Form.Label>
                                <Form.Control type="text" placeholder="Enter the regular price" />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Current Price</Form.Label>
                                <Form.Control type="text" placeholder="Enter the current price" />
                            </Form.Group>
                        </Col>
                    </Row>
                    {/* Specifications */}
                    <h5 className={styles.SubTitle}>Specifications</h5>
                    <hr className={styles.SubDivider} />
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Memory</Form.Label>
                                <Form.Control type="text" placeholder="Enter the special name" />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>CPU</Form.Label>
                                <Form.Control type="text" placeholder="Enter the special name" />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Storage</Form.Label>
                                <Form.Control type="text" placeholder="Enter the special name" />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Screen</Form.Label>
                                <Form.Control type="text" placeholder="Enter the special name" />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Camera</Form.Label>
                                <Form.Control type="text" placeholder="Enter the special name" />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Tags</Form.Label>
                                <Form.Control type="text" placeholder="Enter the special name" />
                            </Form.Group>
                        </Col>
                    </Row>
                    <h5 className={styles.SubTitle}>Thumbnail Image</h5>
                    <hr className={styles.SubDivider}/>
                    <Form.Group>
                        <Form.Label>Device Thumbnail</Form.Label>
                        <Form.File
                            id="special-img"
                            label="Insert the special image here"
                            custom
                        />
                    </Form.Group>
                    <Button variant="success">Add Device</Button>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default DevicesForm;